import { baseRestService } from '@/utils/baseRestService';
import { Config } from '@/config';

class MediaService extends baseRestService {
  constructor() {
    super();
    this.baseUrl = Config.api.apiServerUrl;
  }

  async List(id: number, type: string): Promise<server.mediaDetail[]> {
    let result = await this.Get<server.mediaDetail[]>(`/api/image/${type}/${id}`) || [];
    return result;
  }

  async Detail(id: number): Promise<server.mediaDetail> {
    let result = await this.Get<server.mediaDetail>(`/api/image/${id}`);
    return result;
  }

  async Upload(obj: server.mediaUpload): Promise<server.mediaDetail> {
    const result = await this.Post<server.mediaDetail>(`/api/image`, {
      buffer: obj.buffer,
      format: obj.format,
      type: obj.type,
      typeId: obj.typeId,
      container: obj.container
    }, { returnjson: true });
    return result;
  }

  async Remove(id: number, container: string): Promise<void> {
    const result = await this.Delete<void>(`/api/image/${id}`, { container });
    return result;
  }
}

export const mediaService = new MediaService();
